import React from 'react'

export default function AltPage() {
  return (
    <div>
        <h3 className='mt-5'>Coming Soon!</h3>
    </div>
  )
}
